"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollAreaScrollStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _resolveGutterLength = require("../utils/resolveGutterLength");
// Needed to provide a non-scrolling layout for positioning the keyline

// Parent of body content. Provides scrolling context
const ScrollAreaScrollStyled = (0, _styled.default)("div", {
  shouldForwardProp: propName => {
    switch (propName) {
      case "direction":
      case "gutter":
      case "isScrollable":
        return false;
      default:
        return true;
    }
  }
})`
    display: flex;
    flex-direction: ${_ref => {
  let {
    direction
  } = _ref;
  return direction === "horizontal" ? "row" : "column";
}};
    flex: 1 1 auto;

    ${_ref2 => {
  let {
    direction
  } = _ref2;
  if (direction === "horizontal") {
    return `
                max-height: 100%;
            `;
  } else {
    return `
                max-width: 100%;
            `;
  }
}}

    padding: ${_ref3 => {
  let {
    direction,
    gutter
  } = _ref3;
  // Don't use gutter for horizontal scroll areas. We would rather see people place their own
  // padding on the content.
  if (direction === "horizontal") {
    return "";
  }
  switch (gutter) {
    case "none":
      return "0px";
    case "legacy":
      return `0px ${_spacing.sizes.large}px 0px ${_spacing.sizes.xLarge}px`;
    default:
      return `0px ${(0, _resolveGutterLength.resolveGutterLength)(gutter)};`;
  }
}};
    // Keep scrollbar 8px off the edge for a legacy gutter to preserve back-compat.
    // Otherwise we want consumers to be able to specify their own margins.
    margin-right: ${_ref4 => {
  let {
    direction,
    gutter
  } = _ref4;
  return direction === "vertical" && gutter === "legacy" ? _spacing.sizes.xSmall : 0;
}}px; // keep scrollbar 8px off the edge

    overflow-y: ${_ref5 => {
  let {
    direction
  } = _ref5;
  return direction === "horizontal" ? "hidden" : "auto";
}};
    overflow-x: ${_ref6 => {
  let {
    direction
  } = _ref6;
  return direction === "horizontal" ? "auto" : "hidden";
}};

    @media (min-width: 320px) and (max-width: 480px) {
        height: 100%;
    }
    // This odd linethat doesn't seem to do anything is needed for a bugfix
    // where an ancestor picked up the height of the hidden scroll content
    // https://git.lab.smartsheet.com/design-systems-team/lodestar-core/-/issues/649
    transform: scale(1);
`;
exports.ScrollAreaScrollStyled = ScrollAreaScrollStyled;
//# sourceMappingURL=ScrollAreaScrollStyled.js.map